import { AfterViewInit, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from "../../../config-provider.service";
import { MatProgressBar, ProgressBarMode } from "@angular/material/progress-bar";

@Component({
  selector: 'full-width-loader',
  providers: [],
  styleUrls: ['./full-width-loader.scss'],
  standalone: true,
  imports: [
    MatProgressBar
  ],
  templateUrl: './full-width-loader.html'
})
export class FullWidthLoaderComponent implements AfterViewInit {
    @Input() public mode: ProgressBarMode = 'indeterminate';
    @Input() public position = 'fixed';
    @Input() public anchor = 'top';
    @Input() public color = 'accent';
    @Input() public progress = 0;
    @Input() public buffer = 0;
    constructor(
        public conf: ConfigProvider,
        private translater: TranslateService
    ) {
    }

    public ngAfterViewInit() {
    }
}
